
//$(document).foundation()

var container = $('html, body');

$(window).on("load resize",function(e){
var windowWidth = $(window).width();
if(windowWidth < 1000) {
  $('.window-size').text(windowWidth);
  $('.window-device').text('mobile');
  $('body').removeClass('desktop').addClass('mobile');
  // activateAccountMenu();
  activateSearchPanel();
  // activateMainNavigation();
  editListItem();
}
else {
  $('.window-size').text(windowWidth);
  $('.window-device').text('desktop');
  $('body').removeClass('mobile').addClass('desktop');
  // activateAccountMenu();
  activateSearchPanel();
  // activateMainNavigation();
  editListItem();
}
});

//

var activateAccountMenu = function () {

	$('#wb-button-left-nav, #account-menu-trigger').unbind('click');
	$('#wb-button-left-nav, #account-menu-trigger').bind('click', function() {
		$('header.wb-main-navigation').addClass('active-pane');
	});
	$('header.wb-main-navigation, #wb-main-navigation-close').unbind('click');
	$('header.wb-main-navigation, #wb-main-navigation-close').bind('click', function(e) {
		e.stopPropagation();
		$('header.wb-main-navigation').removeClass('active-pane');
	});
}

var activateMainNavigation = function () {
	$('#wb-main-navigation-trigger, #account-menu-trigger').unbind('click');
	$('#wb-main-navigation-trigger, #account-menu-trigger').bind('click', function() {
		$('#wb-main-navigation').addClass('active-pane');
	});
	$('#wb-main-navigation, #wb-main-navigation-close').unbind('click');
	$('#wb-main-navigation, #wb-main-navigation-close').bind('click', function(e) {
		e.stopPropagation();
		$('#wb-main-navigation').removeClass('active-pane');
	});
}

var activateSearchPanel = function () {
	$('#wb-menu-button-search, #wb-button-search-mobile, #quote-search-trigger').unbind('click');
	$('#wb-menu-button-search, #wb-button-search-mobile, #quote-search-trigger').bind('click', function() {
			$('#wb-search-pane').addClass('active-pane');
			container.addClass('noscroll');

	});
	$('#wb-menu-button-search-close').unbind('click');
	$('#wb-menu-button-search-close').bind('click', function(e) {
		e.stopPropagation();

		$('#wb-search-pane').removeClass('active-pane');
		container.removeClass('noscroll');
	});
}

var statusToggle = function () {
	$('.item-status').on('click', function() {
		$(this).toggleClass('active-item');
	});
}
statusToggle();

var hideQuote = function () {
  $('.list-item-edit').unbind('click');
  $('.list-item-edit').bind('click', function() {
    if($('#wb-search-pane').hasClass('active-pane')) {
      $(this).parents('.wb-card').removeClass('edit-item').find('.item-status').addClass('highlighted').find('i').text('check_circle');
    }
    else {
      $(this).parents('.wb-card').addClass('hiding-card').append('<div class="hide-card"></div>');
      hideQuote2();
    }
  });
}
hideQuote();

// COMPONENTS

// Input focus

var input_focus = function () {
  $('.input-control input[type="text"]').unbind('focusin');
  $('.input-control input[type="text"]').unbind('focusout');
  $('.input-control input[type="text"]').bind('focusin', function() {
    curr_input = $(this);
    va = curr_input.attr('placeholder');
    curr_input.before('<label>' + va + '</label>');
    curr_input.prev('label').hide().fadeIn(500);
    curr_input.attr('placeholder', '');
  });
  $('.input-control input[type="text"]').bind('focusout', function() {
    curr_input = $(this);
    curr_label = curr_input.prev('label');
    curr_input.attr('placeholder', curr_label.text());
    curr_input.prev('label').fadeOut(300, function () {
      curr_label.remove();
    });
    if (curr_input.val() != 0) {
      curr_input.addClass('done');
    }
    else {
      curr_input.removeClass('done');
    }
  });
}
input_focus();

// Select controls

var controlsSelect = function () {

  $('.controls li').unbind('click');
  $('.controls li').bind('click', function () {
    //alert();
    //event.preventDefault();
    // if ($(this).hasClass('active')) {
    //   //$(this).removeClass('active');
    // }
    // else {
      //$(this).parents('.controls').find('li').removeClass('active');
      
      var toggle = $(this).parents('.controls').hasClass('toggle');
      if(toggle) {
        $(this).parents('.controls').find('li').removeClass('active-control');
        $(this).toggleClass('active-control');
      }
      else {
        $(this).toggleClass('active-control');
      }
    // }
  });
}
controlsSelect();

// Census cards

var includeDEP = function () {
	$('.include-dependent').unbind('click');
	$('.include-dependent').bind('click', function () {
		if($(this).hasClass('included')) {
			$(this).removeClass('included');
		}
		else {
			$(this).parents('.wb-employee').find('.include-employee').addClass('included');
			$(this).addClass('included');
		}
	});
}
includeDEP();

var includeEE = function () {
	$('.include-employee').unbind('click');
  	$('.include-employee').bind('click', function () {
  		if($(this).hasClass('included')) {
  			$(this).parents('.wb-employee').find('.include-dependent').removeClass('included');
  			$(this).removeClass('included');
  			$(this).parents('.wb-employee').find('.dependent-count').removeClass('included').removeClass('half-included');
  		}
  		else {
  			$(this).parents('.wb-employee').find('.include-dependent').addClass('included');
  			$(this).addClass('included');
  			$(this).parents('.wb-employee').find('.dependent-count').addClass('included').removeClass('half-included');
  		}
  	});
}
includeEE();

var showDependents = function () {
	$('.dependent-count').unbind('click');
	$('.dependent-count').bind('click', function () {
		$(this).parents('.wb-employee').find('.dependents').slideToggle();
	});
}
showDependents();

var employeeDetails = function() {
	$('.employee-title, #add-employee').unbind('click');
	$('.employee-title, #add-employee').bind('click', function () {
		$('section.wb-popup').fadeIn();
	});

}
employeeDetails();

var popupClose = function() {
	$('#wb-popup-close, #close-popup-button').unbind('click');
	$('#wb-popup-close, #close-popup-button').bind('click', function () {
		$('section.wb-popup').fadeOut();
	});
  	
}
popupClose();

var closeOverlay = function () {
  $('.wb-overlay').unbind('click');
  $('.wb-overlay').bind('click', function () {
    $('section.wb-popup').fadeOut();
  });
}
closeOverlay();

var closeSmallOverlay = function () {
  $('.wb-overlay-small').unbind('click');
  $('.wb-overlay-small').bind('click', function () {
    $('section.wb-popup-small').fadeOut();
  });
}
closeSmallOverlay();

// SMALL POPUP

var smallPopupOpen = function() {
  $('.small-popup-trigger').unbind('click');
  $('.small-popup-trigger').bind('click', function () {
    $('section.wb-popup-small').fadeIn();
  });

}
smallPopupOpen();

var smallPopupClose = function() {
  $('.small-popup-close').unbind('click');
  $('.small-popup-close').bind('click', function () {
    $('section.wb-popup-small').fadeOut();
  });
    
}
smallPopupClose();


// Flow Header

function hideTopNav() {


  // var prev = 0;
  // var $window = $(window);
  // //var nav = $('#flow-header');
  // var nav = $('#flow-header, #flow-footer');

  // $window.on('scroll', function(){
  //   var scrollTop = $window.scrollTop();
  //   nav.toggleClass('nav-up', scrollTop > prev);
  //   prev = scrollTop;
  // });

  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $('#flow-header').outerHeight();
  var navbarHeight = 10;

  $(window).scroll(function () {
    
    var st = $(this).scrollTop();
    if (st >= navbarHeight) {
      $('#flow-header').addClass('nav-up');
    }
    else {
      $('#flow-header').removeClass('nav-up');
    }
  });

  $(window).scroll(function(){
      didScroll = true;
  });

  setInterval(function() {
      if (didScroll) {
          //hasScrolled();
          didScroll = false;
      }
  }, 250);

}

hideTopNav();


//

var editListQuote = function () {
  $('.wb-hide-quote').unbind('click');
  $('.wb-hide-quote').bind('click', function () {
    if ($(this).parents('.wb-quote-list-item').hasClass('edit-item')) {
      $('.wb-quote-list-item').removeClass('edit-item');
    }
    else {
      $('.wb-quote-list-item').removeClass('edit-item');
      $(this).parents('.wb-quote-list-item').toggleClass('edit-item');
    }
  });
}
editListQuote();

// generic, edit list item

var editListItem = function () {
  $('.wb-hide-item').unbind('click');
  $('.wb-hide-item').bind('click', function () {
    if ($(this).parents('.coverage-card, .dental-card, .vision-card, .life-card').hasClass('edit-item')) {
      $('.coverage-card, .dental-card, .vision-card, .life-card').removeClass('edit-item');
    }
    else {
      $('.coverage-card, .dental-card, .vision-card, .life-card').removeClass('edit-item');
      $(this).parents('.coverage-card, .dental-card, .vision-card, .life-card').toggleClass('edit-item');
    }
  });
}
editListItem();


/////////////////////////
// medical coverage
/////////////////////////

// select plans page
// activate select box and navigation

var select_box = function () {
  $('.select-box').unbind('click');
  $('.select-box').bind('click', function(event) {

    $(this).parents('.plan').find('.employee-box').find('li').each(
      function() {
        if ($(this).hasClass('active-item')) {
          count = $(this).index();
          $('.employee-box ul').each(function() {
            $(this).find('li').eq(count).addClass('highlighted');
          });
        }
      }
    );

    event.stopPropagation();

    if($(this).hasClass('select-box-active')) {
      $(this).removeClass('select-box-active');
      var number = $(this).parents('.carousel-cell').index();
      $('ol li').eq(number).attr("data", "");
    }
    else {
      $(this).addClass('select-box-active');
      var number = $(this).parents('.carousel-cell').index();
      $('ol li').eq(number).attr("data", "select");
    }

    if($(this).hasClass('activateGroupDetails')) {
      $('#groupDetails').toggleClass('activeGroupDetails');
    }

  });
}
select_box();

// Medical Coverage, select plans screen

var revealPlanDetails = function () {
  $('.view-more').unbind('click');
  $('.view-more').bind('click', function () {
    $('.carousel-cell.plan .wrap').slideUp();
    $('.view-more').hide();
    $('.benefits-trigger').removeClass('active-item');
    $('.premiums-trigger').removeClass('active-item');
  });
}

revealPlanDetails();

var revealPlanBenefits = function () {
  $('.benefits-trigger').unbind('click');
  $('.benefits-trigger').bind('click', function () {
    if ($(this).hasClass('active-item')) {
      $('.benefits-trigger').removeClass('active-item');
      $('.carousel-cell.plan .wrap').slideUp();
      $('.view-more').hide();
    }
    else {
      $('.benefits-trigger').addClass('active-item');
      $('.premiums-trigger').removeClass('active-item');
      $('.carousel-cell.plan .plan-benefits').slideDown();
      $('.carousel-cell.plan .plan-premiums').hide();
      $('.view-more').show();
    }
  });
}

revealPlanBenefits();

var revealPlanPremiums = function () {
  $('.premiums-trigger').unbind('click');
  $('.premiums-trigger').bind('click', function () {
    if ($(this).hasClass('active-item')) {
      $('.premiums-trigger').removeClass('active-item');
      $('.carousel-cell.plan .wrap').slideUp();
      $('.view-more').hide();
    }
    else {
      $('.premiums-trigger').addClass('active-item');
      $('.benefits-trigger').removeClass('active-item');
      $('.carousel-cell.plan .plan-premiums').slideDown();
      $('.carousel-cell.plan .plan-benefits').hide();
      $('.view-more').show();
    }
  });
}

revealPlanPremiums();

 //Optimized

// var allBenefitsPopup = function () {
//   $('.all-benefits-trigger').unbind('click');
//   $('.all-benefits-trigger').bind('click', function () {

//     $('#plan-benefits').fadeIn();

//   });
// }

// allBenefitsPopup();

var planDetailsPopup = function () {
  $('.plan-details-trigger').unbind('click');
  $('.plan-details-trigger').bind('click', function () {

    $('#plan-details').fadeIn();
    
  });
}

planDetailsPopup();


var planBenefits = function () {
  $('.plan-benefits-trigger').unbind('click');
  $('.plan-benefits-trigger').bind('click', function () {

    $('#plan-details-benefits').fadeIn();
    
  });
}

planBenefits();

var planPremiums = function () {
  $('.plan-premiums-trigger').unbind('click');
  $('.plan-premiums-trigger').bind('click', function () {

    $('#plan-details-premiums').fadeIn();
    
  });
}

planPremiums();

var planSpinner = function () {
  $('.plan-spinner-trigger').unbind('click');
  $('.plan-spinner-trigger').bind('click', function () {

    $('#plan-details-spinner').fadeIn();
    
  });
}

planSpinner();



// Medical Coverage, Apply plans

var applyPlans = function () {
  $('.plan-box li').on('click', function () {
    
    if ($(this).parents('.plan-box').hasClass('all')) {
      $('.plan-box li').removeClass('active-li');
      var count = $(this).index();
      $('.plan-box ul').each(function() {
        $(this).find('li').eq(count).addClass('active-li');
      });
      
    }
    else {
      $(this).parents('ul').find('li').removeClass('active-li');
      $(this).addClass('active-li');
    }

    $('.flickity-page-dots').find('li').attr("data", "");

    $(this).parents('.apply-carousel').find('.carousel-cell').each(function() {
      if($(this).find('li').hasClass('active-li')) {
        var cell = $(this).index();
        $('.flickity-page-dots').find('li').eq(cell).attr("data", "select");
      }
    });
  });
}
applyPlans();


// Click-through prototype

var editQuote = function () {
  $('.wb-quote-list-item .wb-quote-title, .wb-quote-list-item .wb-quote-date').unbind('click');
  $('.wb-quote-list-item .wb-quote-title, .wb-quote-list-item .wb-quote-date').bind('click', function () {
    location.href='00-summary.html';
  });
}
editQuote();


// notifications

var notificationsSlide = function () {
  $('.close-bar').unbind('click');
  $('.close-bar').bind('click', function () {
    $(this).parents('.notifications').toggleClass('notifications-hidden');
  });
}
notificationsSlide();

// Life, include coverage

var incldueCarrier = function () {
  $('.include-carrier').unbind('click');
  $('.include-carrier').bind('click', function () {
    $(this).toggleClass('included');
    $(this).parents('.carousel-cell').find('.content-wrap').slideToggle();
  });
}
incldueCarrier();

var incldueCoverage = function () {
  $('.coverage-item').unbind('click');
  $('.coverage-item').bind('click', function () {
    $(this).toggleClass('included');
  });
}
incldueCoverage();